module.exports = __webpack_public_path__ + "static/media/fornuis.a25b09ec.png";